import api from '../../../lib/axios'
import type { LoginResponse, Requires2FAResponse, AuthenticatedUser } from '@nexuscorp/shared-types'

export interface LoginPayload {
  email: string
  password: string
  totpCode?: string
}

export const authApi = {
  login: async (payload: LoginPayload): Promise<LoginResponse | Requires2FAResponse> => {
    const { data } = await api.post('/auth/login', payload)
    return data.data
  },

  refresh: async (refreshToken: string): Promise<LoginResponse> => {
    const { data } = await api.post('/auth/refresh', { refreshToken })
    return data.data
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout')
  },

  me: async (): Promise<AuthenticatedUser> => {
    const { data } = await api.get('/auth/me')
    return data.data
  },

  setup2fa: async (): Promise<{ secret: string; qrCode: string; message: string }> => {
    const { data } = await api.post('/auth/2fa/setup')
    return data.data
  },

  confirm2fa: async (totpCode: string): Promise<{ message: string; recoveryCodes: string[] }> => {
    const { data } = await api.post('/auth/2fa/confirm', { totpCode })
    return data.data
  },

  disable2fa: async (totpCode: string): Promise<{ message: string }> => {
    const { data } = await api.post('/auth/2fa/disable', { totpCode })
    return data.data
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const { data } = await api.post('/auth/forgot-password', { email })
    return data.data
  },

  resetPassword: async (token: string, password: string): Promise<{ message: string }> => {
    const { data } = await api.post('/auth/reset-password', { token, password })
    return data.data
  },

  acceptInvite: async (token: string, password: string): Promise<{ message: string }> => {
    const { data } = await api.post('/users/accept-invite', { token, password })
    return data.data
  },
}
